var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1012.15744 383.17056V251.50464c0-0.75776-0.18944-1.46944-0.22528-2.22208v-5.1456h-0.51712c-3.60448-25.15456-25.02656-44.55424-51.17952-44.55424H69.94944c-26.15296 0-47.57504 19.39968-51.18464 44.55424H18.0224v186.84416h0.22528v37.24288c-0.03072 0.75264-0.22528 1.4592-0.22528 2.22208v284.1344c0 0.75776 0.18944 1.46944 0.22528 2.22208v5.1456h0.51712c3.60448 25.15456 25.02656 44.55424 51.17952 44.55424h890.28608c26.15296 0 47.57504-19.39968 51.18464-44.55424h0.7424V422.63552h-0.22528v-37.24288c0.03584-0.75264 0.22528-1.4592 0.22528-2.22208z",
    fill: "#E6E4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.71648 637.50144h393.65632v71.8592H205.71648zM634.3168 637.50144h76.0576v71.8592H634.3168zM746.86464 637.50144h76.0576v71.8592h-76.0576zM859.41248 637.50144h76.0576v71.8592h-76.0576zM94.71488 637.50144h76.0576v71.8592H94.71488z",
    fill: "#C8C6C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.71648 625.26976h393.65632v71.8592H205.71648zM634.3168 625.26976h76.0576v71.8592H634.3168zM746.86464 625.26976h76.0576v71.8592h-76.0576zM859.41248 625.26976h76.0576v71.8592h-76.0576z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M753.03424 512.10752h179.3536v71.8592h-179.3536z",
    fill: "#C8C6C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M753.03424 499.87584h179.3536v71.8592h-179.3536z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 392.36608h73.35936v71.8592H427.8016zM536.35072 392.36608h73.35936v71.8592h-73.35936zM644.89984 392.36608h73.35936v71.8592h-73.35936z",
    fill: "#C8C6C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 380.1344h73.35936V451.9936H427.8016zM536.35072 380.1344h73.35936V451.9936h-73.35936zM644.89984 380.1344h73.35936V451.9936h-73.35936z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 392.36608h73.35936v71.8592H94.71488zM203.264 392.36608h73.35936v71.8592H203.264zM311.81312 392.36608h73.35936v71.8592H311.81312z",
    fill: "#C8C6C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 380.1344h73.35936V451.9936H94.71488zM203.264 380.1344h73.35936V451.9936H203.264zM311.81312 380.1344h73.35936V451.9936H311.81312z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 511.08352h73.35936v71.8592H427.8016zM536.35072 511.08352h73.35936v71.8592h-73.35936zM644.89984 511.08352h73.35936v71.8592h-73.35936z",
    fill: "#C8C6C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 498.84672h73.35936v71.8592H427.8016zM536.35072 498.84672h73.35936v71.8592h-73.35936zM644.89984 498.84672h73.35936v71.8592h-73.35936z",
    fill: "#FFFFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 511.08352h73.35936v71.8592H94.71488zM203.264 511.08352h73.35936v71.8592H203.264zM311.81312 511.08352h73.35936v71.8592H311.81312z",
    fill: "#C8C6C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 498.84672h73.35936v71.8592H94.71488zM203.264 498.84672h73.35936v71.8592H203.264zM311.81312 498.84672h73.35936v71.8592H311.81312z",
    fill: "#FFFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 306.176h73.35936v34.9696H427.8016zM536.35072 306.176h73.35936v34.9696h-73.35936zM644.89984 306.176h73.35936v34.9696h-73.35936z",
    fill: "#C8C6C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M427.8016 296.72448h73.35936v34.9696H427.8016zM536.35072 296.72448h73.35936v34.9696h-73.35936zM644.89984 296.72448h73.35936v34.9696h-73.35936z",
    fill: "#FFFFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M750.47936 392.36608h73.35936v71.8592h-73.35936zM859.02848 392.36608h73.35936v71.8592h-73.35936z",
    fill: "#C8C6C4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M750.47936 380.1344h73.35936V451.9936h-73.35936zM859.02848 380.1344h73.35936V451.9936h-73.35936z",
    fill: "#FFFFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M750.47936 306.176h73.35936v34.9696h-73.35936zM859.02848 306.176h73.35936v34.9696h-73.35936z",
    fill: "#C8C6C4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M750.47936 296.72448h73.35936v34.9696h-73.35936zM859.02848 296.72448h73.35936v34.9696h-73.35936z",
    fill: "#FFFFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 306.176h73.35936v34.9696H94.71488zM203.264 306.176h73.35936v34.9696H203.264zM311.81312 306.176h73.35936v34.9696H311.81312z",
    fill: "#C8C6C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.71488 296.72448h73.35936v34.9696H94.71488zM203.264 296.72448h73.35936v34.9696H203.264zM311.81312 296.72448h73.35936v34.9696H311.81312zM94.71488 625.26976h76.0576v71.8592H94.71488z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardImg);
export default __webpack_public_path__ + "static/media/keyboard-img.7f35d95d6b605d056337e5ae1a3301ec.svg";
export { ForwardRef as ReactComponent };